// DAS-2722: extract the plain "which metrics moved" drivers out of the stored
// fundamental_trend_analysis_text (Ticker_Performance_Data), e.g.:
//   "🟢 Positive: EPS (+18.8%, 24%w, ×0.7), Margins (+42.1%, 20%w, ×1.0)"
//   "🔴 Negative: Revenue (-21.1%, 22%w, ×1.0)"
// We keep only "Metric +X%" and drop the internal weight/magnitude shorthand
// (24%w, ×0.7) so the tooltip stays plain-language for the owner.
//
// Pure + exported so the regex (fragile on an emoji/free-text format) is unit-tested.

export function parseTrendDrivers(text) {
  const pick = (marker) => {
    if (!text) return [];
    const line = String(text).split('\n').find((l) => l.includes(marker));
    if (!line) return [];
    const out = [];
    // Metric name immediately followed by "(<signed number>"; ignores the trailing
    // ", 24%w, ×0.7" and any non-name tokens between metrics.
    const re = /([A-Za-z][A-Za-z ]*?)\s*\(\s*([+-][\d.]+)\s*%?/g;
    let m;
    while ((m = re.exec(line)) !== null) out.push(`${m[1].trim()} ${m[2]}%`);
    return out;
  };
  return { up: pick('Positive:'), down: pick('Negative:') };
}
